import { DrawingDto, DrawingRequestDto } from 'src/api/FiretrolApiClient';
import { drawingApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleMutations } from 'src/api/queries/workflowModules/createModuleMutations';
import { queryKeys } from 'src/api/queries/queryKeys';

const mutations = createModuleMutations<DrawingDto, DrawingRequestDto>({
  label: 'drawing',
  saveOp: 'drawing.save',
  detailKey: queryKeys.drawings.detail,
  getId: (dto) => dto.id,
  save: (jobId, request) =>
    drawingApiClient.createOrUpdateDrawing(jobId, request),
  attachFromDocument: (jobId, documentId) =>
    drawingApiClient.attachFromDocument(jobId, { documentId }),
  rotateExternalAccess: (jobId, id) =>
    drawingApiClient.rotateExternalAccess(jobId, id),
  uploadTempFile: (file, category) =>
    drawingApiClient.uploadTempFile(
      { data: file, fileName: file.name },
      category,
    ),
  generatePdf: (jobId, id) => drawingApiClient.generateDrawingPdf(jobId, id),
  previewPdf: (jobId, id) => drawingApiClient.previewDrawingPdf(jobId, id),
  logPdf: (jobId, statuses, contactId) =>
    drawingApiClient.getDrawingLogPdf(jobId, statuses, contactId),
});

export const useSaveDrawing = mutations.useSave;
export const useAttachDrawingDocument = mutations.useAttachFromDocument;
export const useRotateDrawingExternalAccess = mutations.useRotateExternalAccess;
export const useGenerateDrawingPdf = mutations.useGeneratePdf;
export const usePreviewDrawingPdf = mutations.usePreviewPdf;
export const useDrawingLogPdf = mutations.useLogPdf;
